import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RevealAnimation from './RevealAnimation';

interface IconProps {
  className?: string;
}

function FogIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-fog"
    >
      <defs>
        {/* Clip paths for wind line reveal animations */}
        <clipPath id="fog-wind-clip-1">
          <rect x="30" y="68" width="60" height="25">
            <RevealAnimation startX={30} width={60} duration={2.5} delay={0} />
          </rect>
        </clipPath>
        <clipPath id="fog-wind-clip-2">
          <rect x="30" y="81" width="62" height="20">
            <RevealAnimation
              startX={30}
              width={62}
              duration={2.5}
              delay={0.5}
            />
          </rect>
        </clipPath>
        <clipPath id="fog-wind-clip-3">
          <rect x="64" y="89" width="24" height="12">
            <RevealAnimation
              startX={64}
              width={24}
              duration={2.5}
              delay={1.0}
            />
          </rect>
        </clipPath>
      </defs>
      <path
        d="M60.1152 23C72.3292 23 82.2305 32.9012 82.2305 45.1152C82.2305 45.5608 82.2164 46.0033 82.1904 46.4424H84.3457C93.6283 46.4424 101.154 53.9674 101.154 63.25C101.154 72.5325 93.6282 80.0576 84.3457 80.0576H34.8076C25.5251 80.0576 18.0002 72.5325 18 63.25C18 53.9674 25.525 46.4424 34.8076 46.4424H38.04C38.014 46.0033 38 45.5608 38 45.1152C38 32.9013 47.9013 23.0001 60.1152 23Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      {/* Wind line 1 - original path with clip reveal */}
      <path
        d="M58.6446 79.3726C71.2558 68.8892 84.5262 74.2896 87.3726 75.6461C88.1203 76.0026 88.438 76.8979 88.0816 77.6456C87.7252 78.3934 86.8298 78.71 86.082 78.3537C83.5049 77.1254 71.7553 72.3749 60.5621 81.6797C48.2125 91.9455 37.0189 90.5071 31.4759 87.2977C30.7591 86.8826 30.5143 85.9651 30.9294 85.2482C31.3445 84.5314 32.2621 84.2867 32.9789 84.7017C37.355 87.2354 47.1901 88.8945 58.6446 79.3726Z"
        fill="white"
        clipPath="url(#fog-wind-clip-1)"
      />
      {/* Wind line 2 - original path with clip reveal */}
      <path
        d="M59.9179 88.2173C66.1659 83.0235 72.1446 81.7195 76.9671 81.9467C81.7452 82.1718 85.2867 83.8968 86.6701 84.5561C87.4177 84.9126 87.7345 85.808 87.3782 86.5557C87.0217 87.3033 86.1263 87.6201 85.3786 87.2637C84.05 86.6305 80.9681 85.1387 76.8261 84.9436C72.7281 84.7505 67.4894 85.8242 61.8354 90.5243C49.4588 100.813 36.4898 99.224 30.976 96.0315C30.2592 95.6164 30.0144 94.6989 30.4295 93.982C30.8446 93.2652 31.7621 93.0205 32.479 93.4355C36.8844 95.9862 48.4902 97.7169 59.9179 88.2173Z"
        fill="white"
        clipPath="url(#fog-wind-clip-2)"
      />
      {/* Wind line 3 - original path with clip reveal */}
      <path
        d="M65.1745 94.1201C69.6413 90.407 73.9421 89.4594 77.4296 89.6237C80.872 89.786 83.4213 91.0289 84.399 91.4948C85.1468 91.8513 85.4644 92.7465 85.108 93.4943C84.7515 94.2419 83.8561 94.5587 83.1083 94.2024C82.1858 93.7627 80.0952 92.752 77.2884 92.6197C74.5256 92.4895 70.9656 93.2079 67.093 96.4271C66.4559 96.9566 65.5097 96.8689 64.9802 96.2319C64.4508 95.5949 64.5379 94.6497 65.1745 94.1201Z"
        fill="white"
        clipPath="url(#fog-wind-clip-3)"
      />
    </svg>
  );
}

export default memo(FogIcon);
